import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-latest-post',
  templateUrl: './latest-post.component.html',
  styleUrl: './latest-post.component.scss'
})
export class LatestPostsComponent implements OnInit {
  @Input() posts: any
  
  latestPosts: any[] = [];
  public env = environment

  ngOnInit(): void {
    this.extractAndSortPosts();
  }
 
  extractAndSortPosts() {

    // Ordenar os posts pela data
    this.latestPosts = this.posts
      .sort((a: any, b: any) => {
        const dateA = this.parseDate(a.date);
        const dateB = this.parseDate(b.date);
        return dateB - dateA;
      })
      .slice(0, 3); // Pegar apenas os 3 mais recentes
    
  }

  parseDate(dateString: string): number {
    // Assume o formato dd/MM, converter para MM/dd/yyyy
    const [day, month] = dateString.split('/').map(Number);
    const currentYear = new Date().getFullYear(); // Adiciona o ano atual
    return new Date(currentYear, month - 1, day).getTime();
  }
}
